import { useEffect } from 'react'
import { useAuth } from './AuthProvider'
import { clearAuthRedirectUrl, getAuthRedirectUrl, isTransientAuthPath } from './util/login'
import type { Auth0Session } from './util/session'

export default function useAuthCallback(
  onAuthenticated: (err: auth0.Auth0Error, session: Auth0Session, previousUrl: string) => any
) {
  const { handleRedirectCallback } = useAuth()

  useEffect(() => {
    // Second half of the ENG-1190 guard in `storeAuthRedirectUrl`. That one stops a transient auth
    // route being written; this one stops one already in localStorage being honoured — written by a
    // bundle from before the fix, or by another tab. Consumers redirect straight to this value, and
    // `/logout` there logs the user out again the moment they finish logging in.
    const storedUrl = getAuthRedirectUrl()
    const previousUrl = isTransientAuthPath(storedUrl) ? null : storedUrl

    handleRedirectCallback()
      .then(async (sessionResult) => {
        if (onAuthenticated) {
          onAuthenticated(null, sessionResult, previousUrl)
        }

        clearAuthRedirectUrl()
      })
      .catch((err) => {
        // clear on failure too — this path reports previousUrl as null, so leaving the
        // value behind would only let it hijack an unrelated later login
        clearAuthRedirectUrl()

        if (onAuthenticated) {
          onAuthenticated(err, null, null)
        }
      })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
}
